class Filter {
    constructor(el) {
        this.$form = $(el);
        this.$items = this.$form.find('.js-filter-item');
        this.$togglers = this.$form.find('.js-filter-toggler');
        this.$submit = this.$form.find('.js-filter-submit');
        this.$reset = this.$form.find('.js-filter-reset');
        this.$inputs = this.$form.find(':radio, :checkbox');
        this.$dropdowns = this.$form.find('.js-filter-dropdown');
        this.$results = this.$form.find('.js-filter-results');
        this.$close = this.$form.find('.js-filter-close');

        this.bindOpen();
        this.bindClose();
        this.bindChange();
        this.bindReset();
        this.bindClearBtn();
        this.checkChecked();
    }



    // Открываем только одну выпадашку
    bindOpen() {
        this.$togglers.on('click', (e) => {
            const $parent = $(e.target).closest('.js-filter-item');

            if ($parent.is('._active')) {
                this.$items.removeClass('_active');
                this.$form.removeClass('_active');
            } else {
                this.$items.removeClass('_active');
                $parent.addClass('_active');
                this.$form.addClass('_active');
            }
        });
    }



    // Закрываем внешним кликом
    bindClose() {
        App.H.on('click', (e) => {
            if ( !$(e.target).closest('.js-filter-item').length ) {
                this.$items.removeClass('_active');
                this.$form.removeClass('_active');
            }
        });

        this.$close.on('click', (e) => {
            this.$items.removeClass('_active');
            this.$form.removeClass('_active');
        });
    }



    // Изменили радио/чекбокс
    bindChange() {
        this.$inputs.on('change', (e) => {
            this.checkChecked();
            
            if(!$(e.target).closest('.js-subscription-form').length) {
                this.$submit.removeAttr('disabled');
                this.getFilter();
            }            
        });
    }



    // Нажали кнопку Reset
    bindReset() {
        /**
         * Сбрасываем всю форму
         */
        this.$reset.on('click', (e) => {
            this.$inputs.prop('checked', false);
            this.$items.find('.js-filter-clear').removeClass('_visible');
            this.$items.find('.js-filter-reset').attr('disabled', 'disabled');

            // Проверяем, не находится ли этот фильтр на странице подписки
            if (!this.$reset.closest('.js-subscription-filter-reset')) {
                this.$form.submit();
            }
        });
    }



    // Проверяем, отмечены ли в форме какие-то радиобаттоны
    checkChecked() {
        const checked = this.$form.find(':checked').length;

        /**
         * Если отмеченных нет, то дисейблим кнопку Reset,
         * потому что в ней нет смысла
         */
        if (checked === 0) {
            this.$reset.attr('disabled', true);
        } else {
            this.$reset.removeAttr('disabled');
        }

        this.countChecked();
    }



    // Показываем в кнопке сброса кол-во отмеченных радио
    countChecked() {
        this.$dropdowns.each((i, el) => {
            const checked = $(el).find(':checked').length;
            const $clearBtn = $(el).siblings('.js-filter-clear');

            if (checked === 0) {
                $clearBtn.removeClass('_visible');
            } else {
                $clearBtn.addClass('_visible').find('span').text(checked);
            }
        });
    }



    // Кнопка-крестик сброса
    bindClearBtn() {
        this.$form.find('.js-filter-clear').on('click', (e) => {
            /**
             * Сбрасываем только в этой выпадашке
             */

            $(e.target)
                .closest('.js-filter-item')
                .find(':checked')
                .prop('checked', false);

            // Проверяем, не находится ли этот фильтр на странице подписки
            if (!$(e).closest('.js-subscription-filter-reset')) {
                this.$form.submit();
            } else {
                this.$inputs.prop('checked', false);
                this.$items.find('.js-filter-clear').removeClass('_visible');
                this.$items.find('.js-filter-reset').attr('disabled', 'disabled');
            }
        });
    }



    // Получаем новый фильтр
    getFilter() {
        this.$form.addClass('_disabled');

        $.ajax({
            url: this.$form.attr('action'),
            data: this.$form.serialize(),
            method: this.$form.attr('method') || 'GET',
            cache: true,
            success: (response) => {
                this.updateFilter(response);
                this.$form.removeClass('_disabled');
            },
            error: () => {
                this.$form.removeClass('_disabled');
                console.log('Ошибка получения данных фильтра');
            }
        });
    }



    // Показываем количество найденных результатов
    updateFilter(html) {
        if (!html) { return; }

        const count = $(html).find('.js-filter-found').val();

        if (count === undefined || count === '') {
            this.$results.removeClass('_visible');
        } else {
            this.$results.addClass('_visible').find('span').text(count);

            /**
             * Если нашлось 0 результатов, блокируем кнопку сабмита
             */
            if (+count === 0) {
                this.$submit.attr('disabled', true);
            } else {
                this.$submit.removeAttr('disabled');
            }
        }
    }
}



$('.js-filter').each(function() {
    new Filter(this);
});

$('.js-subscription-form').each(function() {
    new Filter(this);
});


// WEBPACK FOOTER //
// ./_src/js/modules/Filter.js